import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { Container } from 'react-bootstrap';
import { getMyOrderJson, getPrescriptionOrderDetails, trackNow } from 'aster-foundation/core/epharmacy/myorders/redux/actions';
import { getUploadedRxDetails } from 'aster-foundation/core/epharmacy/uploadRX/redux/actions';
import {
  IC_ATTACH_GREY,
  IC_EXPRESS_NEW,
  IC_EXPRESS_SHIPMENT_GIF,
  IC_STANDARD_SHIPMENT_GIF,
  IC_RX_GIF,
  IC_EXPRESS_SHEDULED,
  IC_FLASH_SHIPMENT,
  IC_FLASH_UPCOMING,
  IC_EXPRESS_SHEDULED_DELIVERY,
} from '@common/Assets/images';
import { useRouter } from 'next/router';
import SlickSlider from '../SlickSlider/SlickSlider';
import VerificationStatus from '../VerificationStatus/VerificationStatus';
import {
  MIN_MOBILE_WIDTH,
  errorHandlingEpharmacy,
  getConfigurationValue,
  getDayLabel,
  getReferralPageForGA,
} from '../../Utility/common-utils';
import { upcomingCardClick } from '../../Utility/analytics-utils';
import logger from '../../Utility/logger';
import WithLoader from '../Loader/WithLoader';
import OrderTrackPopUp from '../OrderTrackPopUp/OrderTrackPopUp';
import UpcomingPharmacyOrdersStyled from './UpcomingPharmacyOrdersStyled';
import { APP_LOCAL_DATETIME_FORMAT_SA2, DELIVERY_METHOD, ERX_CONSTANTS, EXPRESS_ICON_URL, FLAGSMITH_KEYS,SCHEDULED_EXPRESS_FLAG } from '../../Utility/constants';
import useWindowDimensions from '../../Context/useWindowDimensions';
import { flagsmith } from '../../Lib/Flagsmith';

const responsive = [
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 820,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 480,
    settings: {
      variableWidth: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 390,
    settings: {
      slidesToShow: 0.5,
      slidesToScroll: 0.5,
    },
  },
  {
    breakpoint: 375,
    settings: {
      slidesToShow: 0.3,
      slidesToScroll: 0.3,
    },
  },
];

const UpcomingPharmacyOrders = (props) => {
  const dispatch = useDispatch();
  const windowWidth = useWindowDimensions();
  const router = useRouter();

  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);
  const appConfigData = useSelector((state) => state?.astercore?.AppConfig?.data?.data);

  const [ordersData, setOrdersData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [orderType, setOrderType] = useState('');
  const [intervalTime, setIntervalTime] = useState();
  const [selectedOrderDetail, setSelectedOrderDetails] = useState();
  const [trackId, setTrackId] = useState('');
  const [vcpOrderId, setVcpOrderId] = useState('');
  const [isTrack, setIsTrack] = useState(false);
  const [isIdPresent, setIsIdPresent] = useState(true);
  const [trackingInformation, setTrackingInformation] = useState();
  const [ordersItems, setOrdersItems] = useState([]);
  const [erxTrackId, setErxTrackId] = useState('');
  const [pomTrackId, setPomTrackId] = useState([]);
  const pageType = getReferralPageForGA(router?.asPath);
  const screenName = router?.pathname;
  const ae_web_scheduled_express = flagsmith.getValue(SCHEDULED_EXPRESS_FLAG, { json: true });
  const isSheduledExpress = ae_web_scheduled_express?.isSheduledExpress;
  const ae_common_api_actions = flagsmith.getValue(FLAGSMITH_KEYS?.COMMON_API_ACTION, { json: true });
  const enableXUserVcpId = ae_common_api_actions?.xUserVcpId || false;
  
  const getCardType = (item, selectedOrderItem, selectedOrderDetail) => {
    if (item?.deliveryMethod === 'Express') {
      return `Order_Express_${selectedOrderItem ? selectedOrderItem?.title : selectedOrderDetail?.status}`;
    } else if (item?.deliveryMethod === 'Standard') {
      return `Order_Standard_${selectedOrderItem ? selectedOrderItem?.title : selectedOrderDetail?.status}`;
    }
  };
  
  const getScreenName = (item, selectedOrderItem, selectedOrderDetail) => {
    if (item?.deliveryMethod === 'Express') {
      return `track_shipment_Express_${selectedOrderItem ? selectedOrderItem?.title : selectedOrderDetail?.status}`;
    } else if (item?.deliveryMethod === 'Standard') {
      return `track_shipment_Standard_${selectedOrderItem ? selectedOrderItem?.title : selectedOrderDetail?.status}`;
    }
  };
  
  const navigateToDetail = async (item) => {
    upcomingCardClick(props?.screenName, 'shipment');
  };

  const getOrdersData = () => {
    const params = {
      isCard: true,
    };
    if(enableXUserVcpId){
      params.userId = userLogin?.id
    }
    dispatch(
      getMyOrderJson({
        params,
        onSuccess: (response) => {
          setOrdersData(response?.body?.orders);
          setIsLoading(false);
        },
        onFailure: (error) => {
          logger.error('Orders By Shipment API Error', error);
          setIsLoading(false);
          errorHandlingEpharmacy(err, true, screenName, pageType);
        },
      }),
    );
  };

  const getImageSrc = (item) => {
    let imageUrl = '';
    if (item?.erxId && !item?.rxOrder) {
      imageUrl = IC_RX_GIF.src;
    }else if (item?.erxId && item?.rxOrder) {
      imageUrl = IC_EXPRESS_SHIPMENT_GIF.src;
    } else if (item?.deliveryMethod === DELIVERY_METHOD.EXPRESS) {
      imageUrl = isSheduledExpress && item?.deliveryTitle === DELIVERY_METHOD.SCHEDULE ?  IC_EXPRESS_SHEDULED_DELIVERY : EXPRESS_ICON_URL;
    } else if (item?.deliveryMethod === DELIVERY_METHOD.FLASH) {
      imageUrl = IC_FLASH_SHIPMENT.src;
    } else if (item?.deliveryMethod === 'Standard') {
      imageUrl = IC_STANDARD_SHIPMENT_GIF.src;
    } else {
      imageUrl = IC_RX_GIF.src;
    }
    return imageUrl;
  };

  const getItemNames = (itemNames, qty) => {
    const nameValues = itemNames?.map((item) => item);
    const name = nameValues?.[0] || nameValues?.[1] || '';
  
    if (name.length >= 28) {
      if (qty > 1) {
        if (windowWidth?.width === 430) {
          return `${name.substring(0, 28)}...`;
        } else if (windowWidth?.width === 375) {
          return `${name.substring(0, 24)}...`;
        } else if (windowWidth?.width === 360) {
          return `${name.substring(0, 22)}...`;
        }
        return `${name.substring(0, 28)}...`;
      } else if (qty === '1') {
        if (windowWidth?.width === 430) {
          return `${name.substring(0, 26)}...`;
        } else if (windowWidth?.width === 375) {
          return `${name.substring(0, 22)}...`;
        } else if (windowWidth?.width === 360) {
          return `${name.substring(0, 22)}...`;
        }
        return `${name.substring(0, 26)}...`;
      }
    }
  
    return name;
  };

  const getTrackShipmentData = (trackingId) => {
    if (userLogin?.id && (vcpOrderId ||trackingId)) {
      const trackItemId = {
        orderNumbers: [
          {
            ...(trackingId ? { orderNo: trackingId } : {}),
            vcpOrderId: vcpOrderId,
          },
        ],
      };
      dispatch(
        trackNow({
          params: trackItemId,
          onSuccess: (response) => {
            setTrackingInformation(response);
            if (response?.orderStatus) {
              setOrdersItems(response?.orderStatus);
            }
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true);
          },
        }),
      );
    }
  };

  const handleErxData = (item) => {
    setErxTrackId(item?.erxId);
    setPomTrackId(item);
  
    if (item?.rxOrder) {
      dispatch(
        getPrescriptionOrderDetails({
          params: item?.erxId,
          onSuccess: (response) => {
            setSelectedOrderDetails(response);
            setTrackingInformation(response);
            if (response?.files) {
              setOrdersItems(response.files);
            }
            setOrderType(response?.type);
            setIsTrack(true);
          },
          onFailure: (error) => {
            errorHandlingEpharmacy(error, true, screenName, pageType);
            logger.error('Prescription Order Fetch details error', error);
          },
        })
      );
    } else if (item?.type === ERX_CONSTANTS.PRESCRIPTION) {
      dispatch(
        getUploadedRxDetails({
          params: {
            erxId: item?.erxId,
          },
          onSuccess: (response) => {
            setSelectedOrderDetails(response);
            if (response?.files) {
              setOrdersItems(response?.files);
            }
            setOrderType(item?.type);
            setIsTrack(true);
          },
          onFailure: (error) => {
            errorHandlingEpharmacy(error, true, screenName, pageType);
            logger.error('Erx Fetch details error', error);
          },
        })
      );
    } else {
      setSelectedOrderDetails(item);
      setOrderType(item?.type);
      setIsTrack(true);
    }
  };

  useEffect(() => {
    if (appConfigData?.length > 0) {
      const value = getConfigurationValue(appConfigData, 'shipmentUpdateInterval');
      setIntervalTime(Number(value));
    }
  }, [appConfigData]);

  useEffect(() => {
    if (router?.query && router.query?.pagename) {
      const erxDetails = {
        type: 'Prescription',
        id: router.query.pagename[1],
      };
      handleErxData(erxDetails);
    }
  }, [router.query.pagename]);

  useEffect(() => {
    if (!trackId) {
      setIsIdPresent(false);
    }
    if (ordersData?.length > 0 && (trackId !== undefined || vcpOrderId )) {
      getTrackShipmentData(trackId);
    }
  }, [trackId, isTrack, vcpOrderId]);

  useEffect(() => {
    if (userLogin?.id) {
      if (props?.data && props?.data.length > 0) {
        setOrdersData(props?.data);
        setIsLoading(false);
      } else {
        getOrdersData();
        setIsLoading(false);
      }
    }
  }, [userLogin?.id, props?.data.length]);

  useEffect(() => {
    // interval call to get updated order status data
    if (userLogin?.id && intervalTime > 0) {
      const interval = setInterval(() => {
        getOrdersData();
      }, intervalTime * 1000);
      return () => clearInterval(interval);
    }
  }, [userLogin?.id, intervalTime]);

  useEffect(() => {
    props?.setLoading(isLoading);
  }, [isLoading]);

  useEffect(() => {
    const erxDetails = {
      type: 'Prescription',
      id: erxTrackId,
    };
    if (isTrack && intervalTime > 0) {
      const interval = setInterval(() => {
        if (orderType === ERX_CONSTANTS.SHIPMENT) {
          getTrackShipmentData(trackId);
        }
        if (erxTrackId && orderType === ERX_CONSTANTS.PRESCRIPTION) {
          handleErxData(pomTrackId || erxDetails);
        }
      }, intervalTime * 1000);
      return () => clearInterval(interval);
    }
  }, [isTrack, intervalTime, vcpOrderId]);

  const handleClose = () => {
    setIsTrack(!isTrack);
    setOrdersItems([]);
  };

  const getBorderClassName = (item) => {
    const className = 'orderBox';
    if (item?.rxOrder) {
      return `${className} erxBox`;
   }

    if (item?.deliveryMethod === DELIVERY_METHOD.EXPRESS) {
       return `${className} expressBox`;
    }

    if (item?.deliveryMethod === DELIVERY_METHOD.FLASH) {
      return `${className} flashBox`;
   }

    return className;
  };

  return (
    ordersData?.length > 0 && (
      <UpcomingPharmacyOrdersStyled>
        <Container>
          <SlickSlider
            sliderSettings={{
              slidesToShow: 2.9,
              infinite: false,
              className: 'upcomingOrdersSlider',
              responsive,
              dots: true,
              slidesToScroll: 2.9,
            }}
          >
            {ordersData.map((item) => (
              <div
                className="item cursor-pointer"
                key={item?.runOrderId}
                onClick={() => {
                  if (item?.type === ERX_CONSTANTS?.SHIPMENT) {
                    navigateToDetail(item);
                    setTrackId(item?.trackId);
                    setVcpOrderId(item?.id);
                  }
                  handleErxData(item);
                }}
              >
                {(item.type === ERX_CONSTANTS.PRESCRIPTION && !item?.rxOrder) ? (
                  <div className="orderBox">
                    <div className="deliveryTimeBox">
                      <div className="statusAndTime">
                        <div className="text">
                          <div className="standardDelivery">
                            <div className="dateAndTime">
                              {item?.formattedDate}
                              <span className="eclipse" />
                              {item?.formattedTime}
                            </div>
                          </div>
                        </div>
                        <div className="orderStatus">
                          <VerificationStatus
                            classStatus="status"
                            label={item?.deliveryTitle}
                            status={
                              item?.deliveryTitle === 'Out for Delivery' || item?.deliveryTitle === 'Out For Delivery'
                                ? 'outForDelivery'
                                : `${item?.deliveryTitle}`
                            }
                            withoutIcon
                          />
                        </div>
                      </div>
                    </div>
                    <div className="shipmentBox no-padding">
                      <div className="expressImage">
                        <Image src={getImageSrc(item)} width={56} height={56} />
                      </div>
                      <div className="deliverySection">
                        <div className="deliveryDetails">
                          <div className="shipmentDetails">
                            <div className="shipmentTitle rxPadding">
                              <div>{item?.type}</div>
                              <div className="itemInfo">
                                <div className="itemName itemNameRx">
                                  <span>
                                    <Image src={IC_ATTACH_GREY} width={15} height={15} />
                                  </span>
                                  <span>
                                    {item?.count} {item?.count > 1 ? 'Documents' : 'Document'}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={getBorderClassName(item)}>
                    <div className="deliveryTimeBox">
                      <div className="statusAndTime">
                        <div className="text">
                          {item?.rxOrder || item?.deliveryMethod === DELIVERY_METHOD.EXPRESS || item?.deliveryMethod === DELIVERY_METHOD.FLASH ? (
                            <div className="deliveryTime">{`Arriving ${getDayLabel(item?.deliveryDate,APP_LOCAL_DATETIME_FORMAT_SA2)} at ${item?.formattedTime}`}</div>
                          ) : (
                            <div className="standardDelivery">
                              <div className="dateAndTime">
                                {item?.formattedDate}
                                <span className="eclipse" /> {item?.formattedTime}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="orderStatus">
                          <VerificationStatus
                            classStatus="status"
                            label={item?.status || item?.deliveryTitle}
                            status={
                              item?.deliveryTitle === 'Out for Delivery' || item?.deliveryTitle === 'Delivered'
                                ? 'outForDelivery'
                                : item?.rxOrder
                                ? `${item?.deliveryTitle}`
                                : 'process'
                            }
                            withoutIcon
                          />
                        </div>
                      </div>
                    </div>
                    <div className={`shipmentBox ${(item?.deliveryMethod === DELIVERY_METHOD.EXPRESS || item?.deliveryMethod === DELIVERY_METHOD.FLASH) ? 'express' : ''}`}>
                      <div className="expressImage">
                        <Image src={getImageSrc(item)} width={56} height={46} />
                        {item?.deliveryMethod === DELIVERY_METHOD.FLASH && (
                          <div
                            className="expressBadge expressImg"
                            style={{
                              backgroundImage: `url(${IC_FLASH_UPCOMING.src})`,
                              backgroundPosition: 'center',
                            }}
                          />
                        )}
                      </div>
                      <div className="deliverySection">
                        <div className="deliveryDetails">
                          <div className="shipmentDetails">
                            <div className="shipmentTitle">
                              {item?.rxOrder ? item?.title : item?.shipment}{' '}
                              <div className="itemInfo">
                                <div className="itemName">{getItemNames(item?.itemNames, item?.count)}</div>
                                {item?.count > 1 && (
                                  <div className="quantity">
                                      <span className={`itemsQuantity ${item?.deliveryMethod === DELIVERY_METHOD.EXPRESS || item?.deliveryMethod === DELIVERY_METHOD.FLASH ? 'express' : ''}`}>
                                      {' '}
                                      +{item?.count - 1} {(item?.count - 1) > 1 ? 'items' : 'item'}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </SlickSlider>
        </Container>
        {isTrack && ordersItems?.length > 0 && (
          <OrderTrackPopUp
            orderDetails={selectedOrderDetail}
            trackInfo={trackingInformation}
            close={handleClose}
            isIdPresent={isIdPresent}
            orderType={orderType}
            isSheduledExpress={isSheduledExpress}
            isMobile={windowWidth?.width <= MIN_MOBILE_WIDTH}
          />
        )}
      </UpcomingPharmacyOrdersStyled>
    )
  );
};

UpcomingPharmacyOrders.propTypes = {
  setLoading: PropTypes.func,
  data: PropTypes.array,
  screenName: PropTypes.string,
};

UpcomingPharmacyOrders.defaultProps = {
  setLoading: () => {},
  data: [],
  screenName: '',
};

export default UpcomingPharmacyOrders;
